import { Directive, Injector, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseDto } from '@authority-labs/api-interfaces';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CrudService } from '../shared/services/crud/crud.service';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class CrudDialogComponent<T extends BaseDto> {
  @ViewChild('form') form: NgForm;
  entity: T;
  isLoading = false;
  readonly = false;
  message: NzMessageService;

  get isNew(): boolean {
    return !(this.entity && this.entity.id);
  }

  get isValid(): boolean {
    return this.form && this.form.valid;
  }

  get submitTitle(): string {
    return this.isNew ? 'button.add' : 'button.save';
  }

  constructor(
    public dialogRef: MatDialogRef<T>,
    public crudSrv: CrudService<T>,
    entity: T,
    injector: Injector
  ) {
    this.message = injector.get(NzMessageService);
    this.entity = entity;
  }

  save(): void {
    if (this.form.valid) {
      this.isLoading = true;

      const sub = this.isNew
        ? this.crudSrv.createOne(this.entity)
        : this.crudSrv.updateOne(this.entity.id, this.entity);

      sub.subscribe(this.onSuccess, this.onError);
    } else {
      Object.values(this.form.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  markFormAsDirty(): void {
    if (this.form && this.form.form) {
      this.form.form.markAsDirty();
    }
  }

  private onSuccess = (resp: T) => {
    this.isLoading = false;
    this.message.create('success', 'הפעולה נשמרה בהצלחה');
    this.dialogRef.close(resp);
  };

  private onError = () => {
    this.isLoading = false;
    this.message.create('error', 'הפעולה נכשלה', {
      nzDuration: 10000
    });
  };
}
